import React from 'react';
import { FaCookie } from 'react-icons/fa';
import './cookies-manage.css';

/**
 * Component to reopen the cookie consent banner
 * Can be placed in footer or settings
 */
const ManageCookies = ({ onOpenCookieSettings }) => {
  const handleClick = () => {
    // Delete the consent cookie to force banner to show again
    document.cookie = 'cookie_consent=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;';
    console.log('Cookie consent cleared, reloading page...');
    // Reload to show banner
    window.location.reload();
  };

  return (
    <button 
      className="cookies-manage-btn"
      onClick={handleClick}
      title="Manage Cookie Preferences"
    >
      <FaCookie className="cookies-manage-icon" />
      <span className="cookies-manage-text">Manage Cookies</span>
    </button>
  );
};

export default ManageCookies;
